import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
// import { useResetStore } from "../stores";
import {  useHistory, useParams} from "react-router-dom";
import "../css/index.css";

export function FormBoxResetPassword() {
  // const [resetState, resetActions] = useResetStore();

  const [password, setPassword] = useState("123456");
  const [passwordConfirm, setPasswordConfirm] = useState("123456");
  const { _id } = useParams();
  const history = useHistory();
  useEffect( async() => {
    document.title = `Forgot Password - Nadi Admin`;
    // await resetActions.checkResetPass({_id});
    // if(resetState.resetNotValid){
    //   toast.error('Token not valid');
    //   history.push("/");
    // }

  }, []);
  


  const handleSubmit = async (event) => {
    event.preventDefault();
    if(password !== passwordConfirm){
      toast.error('Password and confirm password not match');
    }else{
      // try {
        // await resetActions.reset({password, _id });
        //   if (resetState.resetSuccess) {
        //     toast.success('Reset password success');
        //     history.push("/");
        //   }
        // } catch (err) {
        //   console.log(err)
        //   toast.error('Fail to reset password');
        // }
      
      
      
    }


   
  };

  return (
    <div className="w-full">
      <div className=" md:mx-10"></div>
      <form className="mt-5 p-5 md:p-10" onSubmit={handleSubmit}>
        <p className="label text-2xl">Reset Password</p>
        <div className="flex items-center mt-8">
          <div className="flex  items-center">
            Enter your new password and password comfirmation
          </div>
        </div>
        <div className="mb-5" style={{ marginTop: 20 }}>
          <label
            className="label block mb-2 "
            htmlFor="password"
            style={{ fontWeight: "normal" }}
          >
            New Password
          </label>
          <label className="form-control-addon-within radius">
            <input
              id="password"
              type="password"
              className="form-control border-none"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
            <span className="flex items-center pr-4">
              <button
                type="submit"
                className="btn btn-link text-gray-600 dark:text-gray-600 la la-eye text-xl leading-none"
                data-toggle="password-visibility"
              ></button>
            </span>
          </label>
        </div>
        <div className="mb-5">
          <label
            className="label block mb-2 "
            htmlFor="password"
            style={{ fontWeight: "normal" }}
          >
            Password Confirmation
          </label>
          <label className="form-control-addon-within radius">
            <input
              id="password"
              type="password"
              className="form-control border-none"
              value={passwordConfirm}
              onChange={(event) => setPasswordConfirm(event.target.value)}
            />
            <span className="flex items-center pr-4">
              <button
                type="submit"
                className="btn btn-link text-gray-600 dark:text-gray-600 la la-eye text-xl leading-none"
                data-toggle="password-visibility"
              ></button>
            </span>
          </label>
        </div>

        <div>
            <button
              type="submit"
              style={{ backgroundColor: "#F46565", marginTop: 20 }}
              className="group h-12 rounded-full flex items-center justify-center relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Reset Password
            </button>
        </div>
      </form>
    </div>
  );
}
